const DEFAULT_REQ_TEXT = "This field is required";

export const isStrInputLen = (str) => {
  if (!str) return DEFAULT_REQ_TEXT;
  return !str.trim().length && DEFAULT_REQ_TEXT;
};

export const isNumValid = (num) => num === null && DEFAULT_REQ_TEXT;
